var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"icon":"fa-tasks","title":"Taak templates","standalone":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('TaskTemplatesTable')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }